import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as XLSXStyle from 'xlsx-style';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    this.wrapAndCenterCell(worksheet.B2);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    // Use XLSXStyle instead of XLSX write function which property writes cell styles.
    const excelBuffer: any = XLSXStyle.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private wrapAndCenterCell(cell: XLSX.CellObject) {
    const wrapAndCenterCellStyle = { alignment: { wrapText: true, vertical: 'center', horizontal: 'center' } };
    //this.setCellStyle(cell, wrapAndCenterCellStyle);
  }

  /*private setCellStyle(cell: XLSX.CellObject, style: {}) {
    cell.s = style;
  }*/

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }




  public populateExcelData(rows) {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();
    
    // Define headers
    const headers = [
        'Bill Date', 'Bill No', 'Party ID', 'Party Name', 'Product ID', 'Product Name',
        'Rate', 'Qty', 'Amount', 'Tax%', 'CGST', 'SGST', 'IGST', 'Less', 
        'Special Less', 'Discount B', 'Transport', 'Inci Dr', 'inci Cr', 'TCS Amt', 'Total', 'GST No', 'Address', 'StateCode', 'City', 'PinCode'
    ];
    
    // Prepare data array starting with headers
    const worksheetData = [headers];


  for (let i = 0; i < rows.length; i++) {
  const currentItem = rows[i];
  const currentInvoice = currentItem.invoiceno;
  
  // Check if this is the last item of current invoice
  const isLastItemOfInvoice = (i === rows.length - 1) || (rows[i + 1].invoiceno !== currentInvoice);
  
  if (!isLastItemOfInvoice) {
    // Not the last item of invoice, set round_off_amt to 0
    rows[i].round_off_amt = 0;
  }
  // If it's the last item, keep the existing round_off_amt value
}

// Calculate Actual RoundOff
 
   let CgstTot = 0;
    let SgstTot = 0;
    let IgstTot = 0;
    let Net = 0;
    let currentInvoiceNo = 0;


    // First, find the last index of each invoice number
    let invoiceLastIndex : any = {};
    rows.forEach((row, index) => {
      invoiceLastIndex[row.invoiceno] = index;
    });

    // Your existing loop with modification
    rows.forEach((e, index) => {
      // Reset gstTot when invoice number changes
      if (currentInvoiceNo != e.invoiceno) {
        CgstTot = 0;
        SgstTot = 0;
        IgstTot = 0;
        currentInvoiceNo = e.invoiceno;
      }

      e.igst = parseFloat(e.igst).toFixed(2);
      e.cgst = parseFloat(e.cgst).toFixed(2);

      if (Number(e.cgst) > 0) {
        CgstTot += Number(e.cgst) || 0;
      }
      if (Number(e.cgst) > 0) {
        SgstTot += Number(e.cgst) || 0;
      }


      if (Number(e.igst) > 0) {
        IgstTot += Number(e.igst) || 0;
      }

      // Only calculate Net if this is the final entry for this invoice
      if (invoiceLastIndex[e.invoiceno] == index) {
        Net = (Number(e.invrate) - Number(e.discountAmt) - Number(e.boxless)) + CgstTot + SgstTot + IgstTot + Number(e.corcharge);

        if (e.round_off_amt && Number(e.round_off_amt) != 0) {
          e.round_off_amt = Number(e.netamt) - Number(Net);
        }
        console.log("net AMtttttttttttt::", Net, e, CgstTot, SgstTot, IgstTot, e.round_off_amt);
      }
      
    });



    // Populate data rows
    rows.forEach(data => {
        // Calculate derived values
        const lessValue = (data.disamt > 0) ? data.disamt : 0;
        
        let splLessValue = 0;
        let finalLessValue = lessValue;
        if (data.sales_type === 'specialinvoice' && data.disamt > 0) {
            splLessValue = data.disamt;
            finalLessValue = 0; // Clear regular less if special
        }
        
        const lessBValue = (data.box_less_amt > 0) ? data.box_less_amt : 0;
        const inciPositive = (data.round_off_amt > 0) ? data.round_off_amt : 0;
        const inciNegative = (data.round_off_amt < 0) ? -data.round_off_amt : 0;
        
        // Create row data
        const rowData = [
            data.bill_date,
            data.invoiceno,
            data.party_id,
            data.party_name,
            data.prod_id,
            data.prod_name,
          parseFloat(data.rate).toFixed(2) || 0,
          parseFloat(data.qty).toFixed(2) || 0,
          parseFloat(data.amount).toFixed(2) || 0,
            0, // Tax%
          parseFloat(data.cgst).toFixed(2) || 0,
          parseFloat(data.cgst).toFixed(2) || 0,
          parseFloat(data.igst).toFixed(2) || 0,    
          Number(finalLessValue).toFixed(2) || 0,
          Number(splLessValue).toFixed(2) || 0,
          Number(lessBValue).toFixed(2) || 0,
          parseFloat(data.corcharge_per_qty).toFixed(2) || 0,
            inciPositive,
            inciNegative,
            0, // TCS Amt
            parseFloat(data.actual_gross).toFixed(2) || 0,
            data.gst_no,
            data.address,
            data.stateCode,
            data.cityName,
            data.pincode
        ];
        
        worksheetData.push(rowData);
    });
    
    // Create worksheet from data
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    
    // Set column widths (auto-size equivalent)
    const columnWidths = headers.map(() => ({ wch: 15 })); // Default width
    worksheet['!cols'] = columnWidths;
    
    // Apply styling using xlsx-style
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    
    // Style headers (row 0)
    for (let col = range.s.c; col <= range.e.c; col++) {
        const headerCell = XLSX.utils.encode_cell({ r: 0, c: col });
        if (!worksheet[headerCell]) continue;
        
        worksheet[headerCell].s = {
            font: { bold: true },
            alignment: { horizontal: 'center' },
            border: {
                top: { style: 'thin' },
                bottom: { style: 'thin' },
                left: { style: 'thin' },
                right: { style: 'thin' }
            }
        };
    }
    
    // Apply borders and number formatting to all data cells
    for (let row = range.s.r; row <= range.e.r; row++) {
        for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
            if (!worksheet[cellAddress]) continue;
            
            // Initialize cell style if not exists
            if (!worksheet[cellAddress].s) {
                worksheet[cellAddress].s = {};
            }
            
            // Add borders
            worksheet[cellAddress].s.border = {
                top: { style: 'thin' },
                bottom: { style: 'thin' },
                left: { style: 'thin' },
                right: { style: 'thin' }
            };
            
            // Format number columns (G, H, I, J, K, L, M, N, O, P, Q, U - indices 6-20 except 17,18)
            const numberColumnIndices = [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
            if (row > 0 && numberColumnIndices.includes(col)) { // Skip header row
                worksheet[cellAddress].s.numFmt = '0.00';
            }
        }
    }
    
    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Tally Export');
    
    return workbook;
}

// Function to download the Excel file
public downloadExcelFile(rows, filename) {
    const workbook = this.populateExcelData(rows);
    
    // Write workbook to buffer
    const excelBuffer = XLSX.write(workbook, { 
        bookType: 'xlsx', 
        type: 'array',
        bookSST: false 
    });
    
    // Create blob and download
    const blob = new Blob([excelBuffer], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
    });
    
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}
  

}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/services/excel.service.ts